import { SaveOutlined } from "@ant-design/icons";
import { debounce } from "@mui/material";
import { Button, Radio, Select, Tooltip } from "antd";
import { ROUTES } from "base/routes/routes";
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { IoArrowBackCircle } from "react-icons/io5";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { DropdownEquipment } from "services/commonDate_services";
import { DataInputRouting } from "services/routing_services";
import { User } from "services/user_services";
import {
  commonDatePresenter,
  commonDateStore,
  routingPresenter,
  routingStore,
} from "stores/root_store";
import { URL_HOME } from "utils/constants";
import { getUserSession } from "utils/localStorageHelper";

const createUpdateRoutingOrTransfer = () => {
  return observer(() => {
    const navigate = useNavigate();
    // Get data params from url
    const { id: stepIdParams } = useParams();

    try {
      const pagePermissions = () => {
        // Kiểm tra đường dẫn
        // check phân quyền bằng đường dẫn
        // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
        const path = window.location.pathname;
        const user = getUserSession() as User;
        const filteredData = user.webPermission.pageModel.filter((item) => {
          const itemNames = item.pageUrl.split(" ");
          return itemNames.some((name) => path.includes(name));
        });

        if (filteredData.length) {
          const permission = user.webPermission.pagePermissionModel.filter(
            (item) => item.pageId === filteredData[0].pageId
          );
          if (permission.length) {
            if (
              permission.findIndex((item) => item.functionId === "EDIT") === -1
            ) {
              navigate("/" + ROUTES.MASTER_DATA.ROUTING_TRANSFER.LINK);
            }
          }
        }
      };
      pagePermissions();
    } catch (error) {
      console.log(error);
    }

    //==========================STATE===================//
    // Loading
    const [loading, setLoading] = useState(true);
    // Load equipment
    const [listEquipment, setListEquipment] = useState<DropdownEquipment[]>([]);

    // Data detail routing
    const [dataDetailRouting, setDataDetailRouting] = useState<
      DataInputRouting
    >();

    // Default actived value
    const [defaultActived, setDefaultActived] = useState("");
    // Check button save and save continue
    let isSaveAndContinue = false;
    // Params of react-hook-form
    const {
      register,
      trigger,
      setValue,
      watch,
      handleSubmit,
      reset,
      formState: { errors },
    } = useForm<DataInputRouting>();

    const isPrepareEquipment = watch('isPrepareEquipment')
    const isCM = watch('isCM')

    useEffect(() => {
      if (isPrepareEquipment) {
        setValue('isCM', false)
      }
    }, [isPrepareEquipment]);
    useEffect(() => {
      if (isCM) {
        setValue('isPrepareEquipment', false)
      }
    }, [isCM]);
    //==========================FUNCTION===================//
    // Call api list dropdown equipment
    const getListDropdownEquipment = async (keyword: string) => {
      await commonDatePresenter.getDropdownEquipment(commonDateStore, keyword);
      if (commonDateStore.dropdownEquipment.isSuccess) {
        setListEquipment(commonDateStore.dropdownEquipment.data);
      }
    };

    // Call api detail routing
    const getDetailRouting = async (stepId: string) => {
      await routingPresenter.getDetailRouting(routingStore, stepId);
      if (routingStore.detailRouting.isSuccess) {
        const dataGetFirst = routingStore.detailRouting
          .data as DataInputRouting;

        const { stepCode, stepName, description, equipmentProduction, unit, isCM, isVS, actived, isIN, isPrepareEquipment, isRequired, workCenterInternalID, workCenterName } = dataGetFirst

        setValue("stepCode", stepCode);
        setValue("stepName", stepName);
        setValue("description", description);
        setValue("equipmentProduction", equipmentProduction);
        setValue("unit", unit);
        setValue("isCM", isCM);
        setValue("isVS", isVS);
        setValue("actived", actived);
        setValue("isIN", isIN);
        setValue("isPrepareEquipment", isPrepareEquipment);
        setValue("workCenterInternalID", workCenterInternalID);
        setValue("workCenterName", workCenterName);
        setValue("isRequired", JSON.stringify(isRequired));

        // Set checked status
        const getActived = dataGetFirst.actived;
        setDefaultActived(getActived ? "actived" : "nonactived");

        setDataDetailRouting(routingStore.detailRouting.data);
        setLoading(false);
      }
    };

    // Call api first access
    useEffect(() => {
      getListDropdownEquipment("");
      if (stepIdParams) {
        getDetailRouting(stepIdParams);
      }
    }, []);

    // Call api update detail routing
    const handleUpdateDetailRouting = async (dataUpdate: DataInputRouting) => {
      // const dataSendApi = {
      //   ...dataUpdate,
      //   stepId: stepIdParams,
      //   // orderIndex: dataDetailRouting?.orderIndex ,
      //   equipmentList: dataDetailRouting?.equipmentList,
      // } as DataInputRouting;
      Object.assign(dataUpdate, {
        stepId: stepIdParams,
        equipmentList: dataDetailRouting?.equipmentList,
        orderIndex:
          dataDetailRouting?.orderIndex === null
            ? undefined
            : dataDetailRouting?.orderIndex,
      });
      const dataUpdateClone = cloneDeep(dataUpdate);
      Object.assign(dataUpdateClone, { isRequired: JSON.parse(dataUpdate.isRequired) })
      // Call api update
      await routingPresenter.updateDetailRouting(routingStore, dataUpdateClone);
      if (routingStore.updateResponse.isSuccess) {
        toast.success(routingStore.updateResponse.message);

        // Redirect to search page routing (Button Save)
        if (!isSaveAndContinue) {
          setTimeout(() => {
            navigate("/MasterData/Routing");
          }, 2000);
        }
      } else {
        toast.error(routingStore.updateResponse.message);
      }
    };

    // Change select requipment
    const handleSelectChange = (value: string[]) => {
      let temptDataDetailRouting = { ...dataDetailRouting } as DataInputRouting;

      const selectedOptions = value.map((v) =>
        listEquipment.find((o) => o.value === v)
      ) as DropdownEquipment[];

      // Check item selected >1
      if (selectedOptions.length > 1) {
        const firstUnit = selectedOptions[0]?.unit;
        const differentUnit = selectedOptions.find((o) => o.unit !== firstUnit);

        if (differentUnit) {
          toast.warning("Không cùng đơn vị công suất. Vui lòng chọn lại!");
          // Delete value before send form
          const selectedValues = selectedOptions.map((o) => o.value);
          const selectedKeys = selectedOptions.map((o) => o.key);
          selectedValues.pop();
          selectedKeys.pop();
          setDataDetailRouting({
            ...temptDataDetailRouting,
            equipmentListStr: selectedValues,
          });
          setValue("equipmentList", selectedKeys);
          return;
        }
      }

      const selectedValues = selectedOptions.map((o) => o.value);
      const selectedKeys = selectedOptions.map((o) => o.key);
      temptDataDetailRouting = {
        ...temptDataDetailRouting,
        equipmentListStr: selectedValues,
        equipmentList: selectedKeys,
      } as DataInputRouting;
      setValue("equipmentList", selectedKeys);

      // Sum equipment production
      const sumEquipmentProduction = selectedOptions.reduce(
        (pre, current) => pre + current.equipmentProduction,
        0
      );
      const unitTemp = selectedOptions[0] ? selectedOptions[0].unit : null;

      temptDataDetailRouting = {
        ...temptDataDetailRouting,
        equipmentProduction: sumEquipmentProduction,
        unit: unitTemp,
      };

      setValue("equipmentProduction", sumEquipmentProduction);
      setValue("unit", unitTemp);

      setDataDetailRouting(temptDataDetailRouting);
    };

    // Clear selected change equipment list
    const handleClearEquipmentList = () => {
      setValue("equipmentList", []);
    };

    // Handle change radio status
    const handleChangeStatus = (e: React.ChangeEvent<HTMLInputElement>) => {
      const valueActived = e.target.value;
      if (valueActived === "actived") {
        setValue("actived", true);
        setDefaultActived("actived");
      }
      if (valueActived === "nonactived") {
        setValue("actived", false);
        setDefaultActived("nonactived");
      }
    };

    return (
      <>
        <div className="w-full py-3 px-5">
          <div className="mb-2 flex justify-between items-center">
            <div className="flex items-center">
              <h3 className="text-md font-bold text-gray-800 uppercase">
                Cập nhật danh mục công đoạn/chuyền
              </h3>
              <Link
                to={`/MasterData/Routing`}
                className="flex items-center text-xs text-primary cursor-pointer ml-3 font-medium whitespace-nowrap"
              >
                <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
                Quay lại
              </Link>
            </div>

            <div className="flex space-x-2">
              <Button
                className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                icon={<SaveOutlined />}
                onClick={() => {
                  isSaveAndContinue = false;
                  handleSubmit(handleUpdateDetailRouting)();
                }}
              >
                Lưu
              </Button>
              <Button
                className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                icon={<SaveOutlined />}
                onClick={() => {
                  isSaveAndContinue = true;
                  handleSubmit(handleUpdateDetailRouting)();
                }}
              >
                Lưu và tiếp tục
              </Button>
            </div>
          </div>
          {loading ? (
            <LoadingScreen />
          ) : (
            <>
              {/* Form nhập */}
              <div className="bg-white w-full p-3.5 flex rounded mb-2 border border-neutral-300">
                <form className="w-full flex flex-col md:gap-x-5 gap-2">
                  {/* Mã công đoạn */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="stepCode"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Mã công đoạn
                    </label>
                    <div className="w-full flex flex-col col-span-3">
                      <input
                        className="bg-[#eee] text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                        id="stepCode"
                        // value={dataDetailRouting?.stepCode}
                        disabled
                        {...register("stepCode", { required: true })}
                      />
                      {errors.stepCode && (
                        <p className="text-[#ffa500] text-xs mt-2 text-start sm:ml-5">
                          Vui lòng nhập thông tin "Mã công đoạn"
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Tên công đoạn */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="stepName"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Tên công đoạn
                    </label>
                    <div className="w-full flex flex-col col-span-3">
                      <input
                        className=" text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                        id="stepName"
                        {...register("stepName", { required: true })}
                      />
                      {errors.stepName && (
                        <p className="text-[#ffa500] text-xs mt-2 text-start sm:ml-5">
                          Vui lòng nhập thông tin "Tên công đoạn"
                        </p>
                      )}
                    </div>
                  </div>

                  {/*Công đoạn in (Có số lượng hàng in về xưởng và ngày hàng in về xưởng) */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="isRequired"
                      className="font-medium text-default flex sm:justify-end text-gray-700 sm:text-end"
                    >
                      <Tooltip
                        className="flex items-center gap-1"
                        title="Công đoạn được tick vẫn có thể xác nhận hoàn thành trong trường hợp không khi nhận sản lượng"
                      >
                        <span className="">Công đoạn Không bắt buộc thực hiện</span>
                        <HiQuestionMarkCircle className="text-primary" />
                      </Tooltip>
                    </label>
                    {/* <input
                      className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="isRequired"
                      type="checkbox"
                      {...register("isRequired")}
                    /> */}

                    <div className="flex items-center">
                      <input
                        {...register("isRequired")}
                        className="h-4 w-4 border border-gray-300 sm:ml-5 px-3 py-1.5 focus-visible:outline-none"
                        type="radio"
                        id="batBuoc"
                        value={'true'}
                      />
                      <label className="text-default ml-1" htmlFor="batBuoc">
                        Bắt buộc
                      </label>
                      <input
                        {...register("isRequired")}
                        className="h-4 w-4 border border-gray-300 sm:ml-5 px-3 py-1.5 focus-visible:outline-none"
                        type="radio"
                        value="false"
                        id="khongBatBuoc"
                      />
                      <label className="text-default ml-1" htmlFor="khongBatBuoc">
                        Không bắt buộc
                      </label>
                    </div>
                  </div>

                  {/*Công đoạn in (Có số lượng hàng in về xưởng và ngày hàng in về xưởng) */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="isIN"
                      className="font-medium text-default flex sm:justify-end text-gray-700 sm:text-end"
                    >
                      <Tooltip
                        className="flex items-center gap-1"
                        title="(Flag phân biệt công đoạn in tại Toàn Phát)"
                      >
                        <span className="">Công đoạn in</span>
                        <HiQuestionMarkCircle className="text-primary" />
                      </Tooltip>
                    </label>
                    <input
                      className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="isIN"
                      type="checkbox"
                      {...register("isIN")}
                    />
                  </div>

                  {/* Máy móc/chuyền */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="equipmentList"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Máy móc/chuyền
                    </label>
                    <Select
                      id="equipmentList"
                      className="col-span-3 text-gray-700 border-0 sm:!ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      mode="multiple"
                      onChange={handleSelectChange}
                      options={listEquipment}
                      value={
                        !Array.isArray(dataDetailRouting?.equipmentListStr)
                          ? []
                          : dataDetailRouting?.equipmentListStr
                      }
                      allowClear
                      onClear={handleClearEquipmentList}
                    />
                  </div>
                  {/* Công suất máy/chuyền */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="machineCapacity"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Công suất máy/chuyền
                    </label>
                    <input
                      className="bg-[#eee] col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      disabled
                      id="machineCapacity"
                      value={dataDetailRouting?.equipmentProduction}
                      {...register("equipmentProduction")}
                    />
                  </div>
                  {/* Đơn vị tính công suất */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="capacityUnit"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Đơn vị tính công suất
                    </label>
                    <input
                      className="bg-[#eee] col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      disabled
                      id="capacityUnit"
                      value={dataDetailRouting?.unit ?? ""}
                      {...register("unit")}
                    />
                  </div>
                  {/* Mô tả */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="description"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Mô tả
                    </label>
                    <input
                      className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="description"
                      {...register("description")}
                    />
                  </div>
                  {/* Thứ tự hiển thị - BA Phượng kêu ẩn đi vì không dùng đến */}
                  {/* <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="orderIndex" className="font-medium text-default text-gray-700 sm:text-end">
                  Thứ tự hiển thị
                </label>
                <input
                  className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="orderIndex"
                  type="number"
                  {...register('orderIndex')}
                />
              </div> */}
                  {/* Canh máy */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="isCM"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Canh máy
                    </label>
                    <div className="flex items-center gap-8">
                      <input
                        className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                        id="isCM"
                        type="checkbox"
                        {...register("isCM")}
                      />

                      <div className="flex items-center">
                        <label htmlFor="isPrepareEquipment" className="font-medium text-default text-gray-700 sm:text-end">
                          Chuẩn bị chuyền
                        </label>
                        <input
                          className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          id="isPrepareEquipment"
                          type="checkbox"
                          {...register("isPrepareEquipment")}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Vệ sinh */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label
                      htmlFor="isVS"
                      className="font-medium text-default text-gray-700 sm:text-end"
                    >
                      Vệ sinh
                    </label>
                    <input
                      className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="isVS"
                      type="checkbox"
                      {...register("isVS")}
                    />
                  </div>
                  {/* Work center Internal ID */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label htmlFor="workCenterInternalID" className="font-medium text-default text-gray-700 sm:text-end">
                      Work center Internal ID
                    </label>
                    <input
                      className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="workCenterInternalID"
                      {...register('workCenterInternalID')}
                    />
                  </div>
                  {/* Tên Workcenter */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label htmlFor="workCenterName" className="font-medium text-default text-gray-700 sm:text-end">
                      Tên Workcenter
                    </label>
                    <input
                      className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="workCenterName"
                      {...register('workCenterName')}
                    />
                  </div>
                  {/* Trạng thái */}
                  <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                    <label className="font-medium text-default text-gray-700 sm:text-end">
                      Trạng thái
                    </label>
                    <div className="flex items-center">
                      <input
                        className="h-4 w-4 border border-gray-300 sm:ml-5 px-3 py-1.5 focus-visible:outline-none"
                        type="radio"
                        id="actived"
                        value="actived"
                        name="actived"
                        onChange={handleChangeStatus}
                        checked={defaultActived === "actived"}
                      />
                      <label className="text-default ml-1" htmlFor="actived">
                        Đang sử dụng
                      </label>
                      <input
                        className="h-4 w-4 border border-gray-300 sm:ml-5 px-3 py-1.5 focus-visible:outline-none"
                        type="radio"
                        id="nonactived"
                        value="nonactived"
                        name="actived"
                        onChange={handleChangeStatus}
                        checked={defaultActived === "nonactived"}
                      />
                      <label className="text-default ml-1" htmlFor="nonactived">
                        Ngưng sử dụng
                      </label>
                    </div>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </>
    );
  });
};

export default createUpdateRoutingOrTransfer;
